import { render, staticRenderFns } from "./R04.vue?vue&type=template&id=f2849334&scoped=true"
import script from "./R04.vue?vue&type=script&lang=js"
export * from "./R04.vue?vue&type=script&lang=js"
import style0 from "./R04.vue?vue&type=style&index=0&id=f2849334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2849334",
  null
  
)

export default component.exports